<template>
  <span
    v-if="name"
    class="camera-platform"
  >
    Платформа: {{ name }}
  </span>
</template>

<script>
import { MEDIA_CORE_NAME } from "@/core/helpers/const";

export default {
  name: "CameraPlatform",
  props: {
    idMediaCore: {
      type: Number,
      default: null,
    },
  },
  computed: {
    // Признак не активный (ТЗ 3): только отображение, редактировать платформу камеры нельзя —
    // привязка идёт через сервер, а не через камеру.
    name() {
      return MEDIA_CORE_NAME[this.idMediaCore] || "";
    },
  },
};
</script>

<style scoped>
.camera-platform {
  margin-right: 16px;
}
</style>
